import React from "react";

export default function ImageLoader() {
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-gray-200 animate-pulse loader">
      <svg
        className="w-6 h-6 text-gray-500 animate-spin"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v8H4z"
        ></path>
      </svg>
    </div>
  );
}
